/* eslint-disable import/prefer-default-export */

export const getRandomString = () => (Math.random() * 1e18).toString(16);
